export interface CampaignAdHocListItem {
  campaignAdHocListId: number;
  listName: string;
  campaignSelectionTarget: string;
  listNotes: string | null;
  listCount: number;
  deleteFlag: boolean;
  listType: string | null;
}

export interface TicketLoyaltyMember {
  loyaltyMemberId: number;
  loyaltySchemaId: number;
  loyaltyCardNumber: string;
}

export interface Member {
  personId: number;
  displayedName: string;
  ticketLoyaltyMemberDto: TicketLoyaltyMember;
}

export enum Target {
  LOYALTY_MEMBER = 'LOYALTYMEMBER',
  PERSON = 'PERSON',
}

export interface ListTypes {
  Empty: 'EMPTY';
  IDs: 'IDS';
  LoyaltyCards: 'LOYALTYCARDS';
  Attributes: 'STRING_ATTRIBUTES';
}

export enum ListTypesEnum {
  EMPTY = 'EMPTY',
  IDS = 'IDS',
  LOYALTY_CARDS = 'LOYALTYCARDS',
  ATTRIBUTES = 'STRING_ATTRIBUTES',
}

export interface CampaignAdHocList {
  campaignAdHocListId: number;
  listName: string;
  campaignSelectionTarget: string;
  listNotes: string | null;
  listCount: number | null;
  deleteFlag: boolean | null;
  listType: string | null;
}

export interface AttributeDetails {
  attributeNames: string[];
  attributeType: string;
}

export interface AttributesCodes {
  attributeCodes: AttributeDetails[];
  entityType: string;
}

export interface ListAttributeType {
  [key: string]: string;
}

export interface AdhocListFilters {
  listName?: string | null;
  selectionTarget?: string;
  listNotes?: string | null;
}
